import React from "react";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

import Tooltip from "../../components/Tooltip";

import css from "./style.scss";

// Renders name cell with Litigator tooltip if applicable
const NameCellRenderer = ({ value, data }) => {
  const isLitigator = data?.isLitigator;
  const id = data && data.id;
  return (
    <Link to={`/contact/0/${id}`} className={css.link} target="detail">
      <p className={css.clsNameText}>
        {value}{" "}
        {isLitigator && (
          <Tooltip
            title={"Litigator"}
            position="top"
            description={
              "A litigator is an individual who may be associated with legal actions, such as filing lawsuits related to telemarketing or consumer protection claims."
            }
            xOffset={-100}
            yOffset={-140}
            arrowOffset={250}
            width={300}
          >
            <span
              style={{ color: "#CA1551", cursor: "pointer", marginLeft: "2px" }}
            >
              (Litigator)
            </span>
          </Tooltip>
        )}
      </p>
    </Link>
  );
};

export default React.memo(NameCellRenderer);

NameCellRenderer.propTypes = {
  /** The cell value to render */
  value: PropTypes.string,
  /** The entire row data */
  data: PropTypes.shape({
      isLitigator: PropTypes.bool,
    }),
};
